/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandInertia = createReactComponent("brand-inertia", "IconBrandInertia", [
  ["path", { d: "M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", key: "svg-0" }],
  ["path", { d: "M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", key: "svg-1" }]
]);

export { IconBrandInertia as default };
//# sourceMappingURL=IconBrandInertia.js.map
